/**
 * Where things stand in the title and story scenes, and where a world point lands on the HUD, so a
 * scene can be checked against the band the menus are drawn in (`TITLE_LAYOUT`, index.ts).
 *
 * GameView shows these scenes through the stage camera focused on the origin: orthographic, 14 HUD
 * pixels to a tile, tilted down 18 degrees (05 §3).
 */

const PPT = 14;
const PITCH = (18 * Math.PI) / 180;
const COS = Math.cos(PITCH);
const SIN = Math.sin(PITCH);

/** HUD pixel (640x360, y down) of a world point (tiles, y up, z toward the camera). */
export function hudOf(x: number, y: number, z: number): { x: number; y: number } {
  return { x: 320 + x * PPT, y: 180 - (y * COS - z * SIN) * PPT };
}

/** The title's figures: Bub left of the menu band, Bob right of it, standing on a floor. */
export const TITLE_SCENE = {
  /** Top of the floor, and where the dragons' feet are (world y). */
  floorY: -11.5,
  /** Half the width of the floor, tiles (the playfield's). */
  floorHalf: 16,
  /** Distance of each dragon from the centre line, tiles. */
  dragonX: 11.8,
  /** Dragon size: the playfield's dragon is 1. */
  dragonScale: 3,
} as const;

/**
 * The story's figures, from the C64's (storyText.ts `STORY_DRAGONS`): each 48x42 picture's centre
 * sits 56 px either side of the screen's centre and 94 px from its top (of 200): 7 tiles either side,
 * 0.75 tiles above the middle. The bubble is the picture's width; the dragon in it the in-game size,
 * shown a little larger here.
 */
export const STORY_SCENE = {
  dragonX: 7,
  centreY: 0.75,
  bubbleRadius: 2.75,
  dragonScale: 1.5,
} as const;
